import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./layout/Header";
import "./App.css";
import Footer from "./layout/Footer";
import Home from "./pages/Home";
import Career from "./pages/Career";
import Products from "./pages/Products";
import { ConfigProvider } from "./Context/ConfigContext";

function App() {
  return (
    <ConfigProvider>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Career" element={<Career />} />
            <Route path="/Products" element={<Products />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </ConfigProvider>
  );
}

export default App;